(function(){
'use strict';
document.documentElement.classList.add('rx-js');
var bar=document.querySelector('[data-rx-shopbar]');
if(bar){
  var phone=window.matchMedia('(max-width: 860px)');
  var on=false;
  var lift=function(){var p=document.getElementById('PBarNextFrameWrapper');bar.style.bottom=p?Math.round(p.getBoundingClientRect().height)+'px':'';};
  var update=function(){
    var h=window.innerHeight;
    var close=document.querySelector('[data-rx-close]');
    var stop=close?close.getBoundingClientRect().top<h*0.75:false;
    var show=phone.matches&&window.scrollY>h*0.85&&!stop;
    if(show===on)return;
    on=show;
    lift();
    bar.classList.toggle('is-on',on);
    bar.setAttribute('aria-hidden',String(!on));
    bar.inert=!on;
  };
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  if(phone.addEventListener)phone.addEventListener('change',update);
  update();
}
var nav=document.querySelector('[data-rx-pnav]');
if(nav){
  var links=[].slice.call(nav.querySelectorAll('.rx-pnav-links a'));
  var select=nav.querySelector('select');
  var targets=links.map(function(a){return document.getElementById(decodeURIComponent(a.hash.slice(1)));});
  var smooth=function(){return window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';};
  var mark=function(){
    var cur=-1;
    targets.forEach(function(t,i){if(t&&t.getBoundingClientRect().top<=140)cur=i;});
    links.forEach(function(a,i){if(i===cur)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
    if(select)select.selectedIndex=cur;
  };
  var jump=function(target,focus){
    if(!target)return;
    history.replaceState(null,'','#'+target.id);
    target.scrollIntoView({block:'start',behavior:smooth()});
    if(focus){if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}
  };
  nav.addEventListener('click',function(e){
    var a=e.target.closest('.rx-pnav-links a');
    if(!a)return;
    e.preventDefault();
    jump(targets[links.indexOf(a)],true);
  });
  if(select)select.addEventListener('change',function(){jump(document.getElementById(select.value),false);});
  window.addEventListener('scroll',mark,{passive:true});
  window.addEventListener('resize',mark);
  mark();
}
if(/^#rx-doc-/.test(location.hash)){
  var d=document.getElementById(location.hash.slice(1));
  if(d&&d.showModal){try{d.showModal();}catch(err){}}
}
})();
